import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, SingleAnswerStepData } from '@packages/shared/core/quiz/entities';

type SingleHorizontalAnswerQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const SingleHorizontalAnswerQuizStep = ({ id, renderQuizScreen }: SingleHorizontalAnswerQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, updateUserPreferences, totalSteps } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as SingleAnswerStepData;

  const goBack = async () => back();

  const onChosen = async (value?: string) => {
    updateUserPreferences(dataKey, value);
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onChosen,
        onBack: goBack,
        totalSteps,
        ...(stepData as SingleAnswerStepData),
      })}
    </>
  );
};

export default SingleHorizontalAnswerQuizStep;
